import { Box, Container, Drawer, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FC, ReactNode, useState } from 'react'
import { OccupancyType, YardSelectorProps } from '../../models/yard-selector.model'
import { YardClerkViewStore } from '../../Stores/YardClerkViewStore'
import { YardClerkUpdatePositionHeader } from '../molecules/YardClerkUpdatePositionHeader'

type Props = {
  yardClerkViewStore: YardClerkViewStore
  yardSelector?: (props: YardSelectorProps) => ReactNode
}

export const YardClerkUpdatePosition: FC<Props> = observer(
  ({ yardClerkViewStore, yardSelector }) => {
    const { t } = useTranslate()
    const [isPositionComplete, setIsPositionComplete] = useState(false)

    const onClose = () => {
      yardClerkViewStore.closeDrawer()
      setIsPositionComplete(false)
    }

    const onConfirm = async () => {
      if (yardClerkViewStore.selectedJourney?.id && isPositionComplete) {
        await yardClerkViewStore.updatePosition(yardClerkViewStore.selectedJourney.id)
        onClose()
      }
    }

    const onPositionChange = (isComplete: boolean) => {
      setIsPositionComplete(isComplete)
    }

    return (
      <Drawer
        open={yardClerkViewStore.isDrawerOpen}
        anchor='right'
        slotProps={{
          paper: {
            sx: {
              width: '100vw',
            },
          },
        }}
      >
        <YardClerkUpdatePositionHeader
          title={yardClerkViewStore.selectedJourney?.containerNumber ?? ''}
          onConfirm={onConfirm}
          onClose={onClose}
        />
        <Stack spacing={2}>
          <Box
            sx={{
              py: '1rem',
              bgcolor: theme => theme.palette.grey[200],
              borderBottom: '1px solid rgba(145, 158, 171, 0.24)',
            }}
          >
            <Container>
              <Typography variant='subtitle1'>{t('checkPosition', 'Check position')}</Typography>
            </Container>
          </Box>
          <Container>
            {yardSelector?.({
              hasError: isPositionComplete === false,
              journeyId: yardClerkViewStore.selectedJourney?.id ?? null,
              stackDirection: 'column',
              prefillPosition: OccupancyType.Occupied,
              onPositionChange: value => {
                onPositionChange(value)
              },
            })}
          </Container>
        </Stack>
      </Drawer>
    )
  },
)
